import { Injectable } from "@angular/core";
import { HttpHandlerService } from "../../http-handler.service";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { Observable } from "rxjs";

@Injectable()

export class DataImportService{
    _httpHandler:HttpHandlerService;
    _apiUrl=environment.apiUrl;
    _getResourceEndPoint= "import";
    _getAWBEndPoint="awb";
    _getODAEndPoint="oda";
    _getChargesEndPoint="charges";

    constructor(private httpHandler:HttpHandlerService,private appTokenService:AppTokenService){
        this._httpHandler=httpHandler;
    }

    public ImportAWB(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getAWBEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ValidateAWB(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getAWBEndPoint}/validate`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ImportODA(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getODAEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ValidateODA(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getODAEndPoint}/validate`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ValidateCharges(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getChargesEndPoint}/validate`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ImportCharges(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getChargesEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

}